import { useState } from "react";
import { Box, Tabs, Tab } from "@mui/material";
import StickerConfig from "./StickerConfig";
import WarehouseConfig from "./WarehouseConfig";

function LabelConfig() {
    const [tab, setTab] = useState(0);

    const handleTabChange = (e, newValue) => {
        setTab(newValue);
    };

    return (
        <Box sx={{ px: 2, pt: 2, mt: "4em" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs value={tab} onChange={handleTabChange}>
                    <Tab label="Sticker Configuration" />
                    <Tab label="Warehouse Configuration" />
                </Tabs>
            </Box>

            {/* Render only the active tab's content. Keeping both mounted but
                CSS-hidden (display: none) broke react-rnd's bounds="parent"
                measurement — it read a 0x0 parent on first mount while hidden,
                so fields sat misaligned until you clicked one and it recalculated.
                Rendering conditionally means each tab only mounts while visible,
                so Rnd always measures the real canvas size.
                Trade-off: switching tabs remounts the other one, so its size
                selection / unsaved edits reset — it refetches config the same
                way it does on first load. */}
            {tab === 0 && <StickerConfig />}
            {tab === 1 && <WarehouseConfig />}
        </Box>
    );
}

export default LabelConfig;